module.exports = __webpack_public_path__ + "static/media/damlag2_768.b266fc19.jpg";